__turbopack_context__.v({
  "btn": "BoardsToggle-module__XPshAW__btn",
  "container": "BoardsToggle-module__XPshAW__container",
  "containerToggled": "BoardsToggle-module__XPshAW__containerToggled",
  "fadeInItems": "BoardsToggle-module__XPshAW__fadeInItems",
  "menu": "BoardsToggle-module__XPshAW__menu",
  "menuItem": "BoardsToggle-module__XPshAW__menuItem",
  "menuLabel": "BoardsToggle-module__XPshAW__menuLabel",
  "mobileOnly": "BoardsToggle-module__XPshAW__mobileOnly",
  "overlay": "BoardsToggle-module__XPshAW__overlay",
  "shareBtn": "BoardsToggle-module__XPshAW__shareBtn",
  "spacing--lg": "BoardsToggle-module__XPshAW__spacing--lg",
  "spacing--md": "BoardsToggle-module__XPshAW__spacing--md",
  "spacing--sm": "BoardsToggle-module__XPshAW__spacing--sm",
  "spacing--xl": "BoardsToggle-module__XPshAW__spacing--xl",
  "spacing--xs": "BoardsToggle-module__XPshAW__spacing--xs",
  "spacing--xxl": "BoardsToggle-module__XPshAW__spacing--xxl",
  "spacing--xxs": "BoardsToggle-module__XPshAW__spacing--xxs",
  "spacing--xxxl": "BoardsToggle-module__XPshAW__spacing--xxxl",
  "spacing--xxxs": "BoardsToggle-module__XPshAW__spacing--xxxs",
  "toggle": "BoardsToggle-module__XPshAW__toggle",
});
